import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3fb4302"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-car-wrap" }
const _hoisted_2 = {
  class: "choose-brand",
  ref: "brandListDom"
}
const _hoisted_3 = { class: "brand-list" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "letter-txt" }, [
  /*#__PURE__*/_createElementVNode("p", null, "热门品牌")
], -1))
const _hoisted_5 = { class: "hot-brand" }
const _hoisted_6 = ["data-fd", "data-index", "data-photo", "data-value", "data-title", "onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "brand-item" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "to-back" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 选择车系 ")
const _hoisted_13 = {
  key: 0,
  class: "list-content"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "no-data"
}
const _hoisted_16 = { class: "to-back" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 选择车型 ")
const _hoisted_18 = {
  key: 0,
  class: "list-content"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "no-data"
}
const _hoisted_21 = {
  key: 0,
  class: "loading-pop"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("加载中...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_index_anchor = _resolveComponent("van-index-anchor")!
  const _component_van_index_bar = _resolveComponent("van-index-bar")!
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotBrandList, (e, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "item",
              "data-fd": e.fd,
              "data-index": e.index,
              "data-photo": e.img,
              "data-value": e.bid,
              "data-title": e.title,
              onClick: ($event: any) => (_ctx.methods.chooseHotBrand(e))
            }, [
              _createElementVNode("img", {
                src: e.img
              }, null, 8, _hoisted_7),
              _createElementVNode("i", null, _toDisplayString(e.title), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_van_index_bar, {
            sticky: "",
            "sticky-offset-top": 0.5,
            "index-list": _ctx.letterList
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_van_index_anchor, {
                    index: item.letter,
                    class: "sub-title-content"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.letter), 1)
                    ]),
                    _: 2
                  }, 1032, ["index"]),
                  (_openBlock(), _createElementBlock("ul", {
                    class: "list-content",
                    key: (index + 1) * 1000
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.brands || [], (i, idx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: idx,
                        onClick: ($event: any) => (_ctx.methods.pickBrand(i))
                      }, [
                        _createElementVNode("img", {
                          src: i.logo96x96
                        }, null, 8, _hoisted_10),
                        _createElementVNode("p", null, _toDisplayString(i.name), 1)
                      ], 8, _hoisted_9))
                    }), 128))
                  ]))
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["sticky-offset-top", "index-list"])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: _normalizeClass(['choose-series', { activ: _ctx.progress === 2 }])
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", {
          class: "back-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.progress = 1))
        }),
        _hoisted_12
      ]),
      (_ctx.noneData == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seriesList, (i, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "caption",
                key: idx
              }, [
                _createElementVNode("p", null, _toDisplayString(i.name), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.serials, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("li", {
                        onClick: ($event: any) => (_ctx.methods.pickSeries(item))
                      }, _toDisplayString(item.sgname), 9, _hoisted_14)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.noneData == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, "暂无车系~"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['choose-model', { activ: _ctx.progress === 3 }])
    }, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", {
          class: "back-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.progress = 2))
        }),
        _hoisted_17
      ]),
      (_ctx.modelList.length !== 0)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelList, (i, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass({ caption: i.caption }),
                key: idx,
                onClick: ($event: any) => (_ctx.methods.pickModel(i))
              }, [
                _createElementVNode("p", null, _toDisplayString(i.title), 1)
              ], 10, _hoisted_19))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, "该车系暂无车型~"))
    ], 2),
    (_ctx.isShowLoadingPop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_van_loading, {
            class: "loading-icon",
            color: '#fff',
            size: "40px"
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}